import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import MetricCard from "./MetricCard";

// Define types
interface Metric {
  label: string;
  value: number;
  value1: number;
  unit?: string;
  color: string;
  displayName: string;
  substanceKey: string;
  count: string;
  isoIndex: string;
  icon?: string;
}

interface MetricsSectionProps {
  title?: string; // optional title
  summaryPage: (data: any) => void;
  metrics: Metric[] | { [key: string]: Metric[] };
}

const MetricsSection: React.FC<MetricsSectionProps> = ({ title, metrics, summaryPage }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        bgcolor: "#fff",
        borderRadius: 2,
        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Render title only if provided */}
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
          {title}
        </Typography>
      )}

      {Array.isArray(metrics) ? (
        // Render if metrics is an array
        <Box
          sx={{
            display: "-webkit-box",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: isMobile ? "center" : "flex-start",
          }}
        >
          {metrics.map((metric, index) => (
            <MetricCard key={index} summaryPage={summaryPage} metric={metric} />
          ))}
        </Box>
      ) : (
        // Render grouped metrics if metrics is an object
        Object.keys(metrics).map((groupKey) => (
          <Box key={groupKey} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, textTransform: "uppercase" }}>
              {groupKey}
            </Typography>
            <Box
              sx={{
                display: "-webkit-box",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: isMobile ? "center" : "flex-start",
              }}
            >
              {metrics[groupKey].map((metric, index) => (
                <MetricCard key={index} summaryPage={summaryPage} metric={metric} />
              ))}
            </Box>
          </Box>
        ))
      )}
    </Box>
  );
};

export default MetricsSection;
